export const isNewUserQueryKey = ["user", "isNewUser"]
export const whoamiQueryKey = ["user", "whoami"]
export const isOnboardingFinishedStorageKey = "isOnboardingFinished"
